'use client';

import { datadogRum } from '@datadog/browser-rum';
import CONFIG from '@whistle/config';

if (['prod', 'stage'].includes(CONFIG.DD_ENV!)) {
  datadogRum.init({
    applicationId: 'bcdda036-d90a-49d9-9632-11c748df4632',
    clientToken: 'pub1e7535171e3e1b8c9c9abe7970a3dde2',
    site: 'datadoghq.com',
    service: 'guest-portal',
    env: CONFIG.DD_ENV,
    version: CONFIG.DD_RELEASE_VERSION,
    sessionSampleRate: CONFIG.DD_ENV === 'prod' ? 100 : 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  });
}

export function DatadogRum() {
  return null;
}
